import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Module} from '../models/module';

@Injectable()
export class ModuleSettingsService {

  constructor(private http: HttpClient) {
  }

  getModules(params) {
    return this.http.post<any>('api/module/all/list', params);
  }

  editModule(module: Module) {
    return this.http.post<any>('api/module/editModule', module);
  }

  getAllModules() {
    return this.http.get<any>('api/module/all');
  }

  getModuleExtensionRights(roleId: number, moduleId: number) {
    return this.http.get<any>('api/module/getExtendedEdits/' + roleId + '/' + moduleId);
  }

  getExtendedEditsForCurrentUser(moduleId: number) {
    return this.http.get<any>('api/module/getExtendedEditsForCurrentUser/' + moduleId);
  }

  saveModuleExtendedEdits(roleId: number, moduleId: number, extendedEdits: any) {
    return this.http.post<any>('api/module/setExtendedEdits/' + roleId + '/' + moduleId, extendedEdits);
  }

  getModuleRightObjects(id: number) {
    return this.http.get<any>('api/module/getAccessRights/' + id);
  }

  setAccessObjects(roleId: number, moduleId: number, accessId: number, selected: any) {
    return this.http.post<any>('api/module/setAccessObjects/' + roleId + '/' + moduleId + '/' + accessId, selected);
  }

  getExtendedAccesses(roleId: number, moduleId: number) {
    return this.http.get<any>('api/module/getExtendedAccesses/' + roleId + '/' + moduleId);
  }

  getExtendedAccessesForCurrentUser(moduleId: number) {
    return this.http.get<any>('api/module/getExtendedAccessesForCurrentUser/' + moduleId);
  }

  deleteAccessObjects(roleExtAccessId: number, moduleId: number, roleId: number, selected: any) {
    return this.http.post<any>('api/module/deleteAccessObjects/' + +roleExtAccessId + '/' + moduleId + '/' + roleId, selected);
  }

  checkModuleLicense(collegeId: number, module: string) {
    return this.http.get<any>('api/module/checkModuleLicense/' + collegeId + '/' + module);
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/admin/services/module-settings.service.ts